import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useAccounts } from '../lib/useAccounts';
import AccountDrawer from '../components/AccountDrawer';
import { shortLocation } from '../lib/accounts';

export default function Vendors() {
  const { demo } = useAuth();
  const { data, loading } = useAccounts(demo);
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState('');

  const vendors = useMemo(() => (data?.accounts ?? []).filter((a) => a.type === 'vendor' || a.type === 'both'), [data]);
  const rows = useMemo(() => {
    if (!q.trim()) return vendors;
    const t = q.toLowerCase();
    return vendors.filter((v) => v.name.toLowerCase().includes(t) || (v.category || '').toLowerCase().includes(t) || (v.materials || []).join(' ').toLowerCase().includes(t));
  }, [vendors, q]);

  const openId = params.get('open');
  const active = vendors.find((v) => v.id === openId) || null;
  const open = (idv: string | null) => { const p = new URLSearchParams(params); if (idv) p.set('open', idv); else p.delete('open'); setParams(p, { replace: true }); };

  if (loading) return <div className="loading"><div className="spinner" /> Loading vendors…</div>;

  return (
    <>
      <div className="page-head">
        <div>
          <div className="page-title">Vendors</div>
          <div className="page-sub">{vendors.length} suppliers — materials, lead times, and performance.</div>
        </div>
        {data && (data.live ? <span className="live-flag">Live · {data.sources.join(' + ')}</span> : <span className="demo-flag">Demo data</span>)}
      </div>

      <div className="toolbar">
        <input className="search" placeholder="Search vendor, category, material…" value={q} onChange={(e) => setQ(e.target.value)} />
      </div>

      <div className="table-wrap">
        <table>
          <thead><tr><th>Vendor</th><th>Category</th><th>Materials</th><th>Avg Lead</th><th>Location</th></tr></thead>
          <tbody>
            {rows.map((v) => (
              <tr key={v.id} onClick={() => open(v.id)}>
                <td><div className="acct-name">{v.name}</div></td>
                <td style={{ color: 'var(--tx2)' }}>{v.category || '—'}</td>
                <td style={{ color: 'var(--tx2)' }}>{(v.materials || []).join(', ') || '—'}</td>
                <td>{v.avgLeadDays != null ? `${v.avgLeadDays} days` : '—'}</td>
                <td>{shortLocation(v)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5}><div className="empty">No vendors match your search.</div></td></tr>}
          </tbody>
        </table>
      </div>

      {active && <AccountDrawer account={active} onClose={() => open(null)} />}
    </>
  );
}
